import React from "react";
import { Award, Ruler, ShieldCheck, Truck, Sparkles, Users } from "lucide-react";

export default function AboutPage() {
  return (
    <div data-testid="about-page">
      <section className="relative overflow-hidden gradient-primary-soft py-20">
        <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8 grid lg:grid-cols-2 gap-12 items-center">
          <div>
            <div className="text-xs font-bold uppercase tracking-[0.25em] text-brand-600 mb-3">Hakkımızda</div>
            <h1 className="font-display text-4xl md:text-6xl font-black tracking-tight text-ink-900">
              Ölçüye Özel Mobilyanın <span className="gradient-text">Adresi</span>
            </h1>
            <p className="mt-5 text-lg text-ink-500 leading-relaxed">
              Malatya Mobilya Tasarım, ölçüye özel üretim yapan, kaliteli malzeme ve titiz işçilikle nesiller boyu kullanılabilen mobilyalar üreten bir atölyedir. Küçük detaylara verdiğimiz önem, işimizin ana felsefesidir.
            </p>
          </div>
          <div className="relative aspect-[4/3] rounded-3xl overflow-hidden brand-shadow-lg">
            <img src="https://images.pexels.com/photos/37162564/pexels-photo-37162564.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940" alt="Atölye" className="w-full h-full object-cover" />
          </div>
        </div>
      </section>

      <section className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8 py-20 grid lg:grid-cols-2 gap-10">
        <div className="rounded-3xl border border-ink-100 bg-white p-8">
          <div className="text-xs font-bold uppercase tracking-widest text-brand-600">Misyon</div>
          <h3 className="mt-2 font-display text-2xl font-bold text-ink-900">Her ölçüye, her mekana özel</h3>
          <p className="mt-3 text-ink-500 leading-relaxed">Standart kalıplara sığmayan hayalleri, ölçüye özel çözümlerle gerçeğe dönüştürmek. Şeffaf fiyatlandırma ve kolay iletişimle güven veren bir üretim ortağı olmak.</p>
        </div>
        <div className="rounded-3xl border border-ink-100 bg-white p-8">
          <div className="text-xs font-bold uppercase tracking-widest text-brand-600">Vizyon</div>
          <h3 className="mt-2 font-display text-2xl font-bold text-ink-900">Bölgenin referans atölyesi</h3>
          <p className="mt-3 text-ink-500 leading-relaxed">Malatya ve çevresinde toplu iş projelerinden bireysel çözümlere kadar tercih edilen, teknolojiyi ve el işçiliğini bir arada kullanan öncü marka olmak.</p>
        </div>
      </section>

      <section className="bg-ink-900 text-white py-20">
        <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
          <div className="text-center max-w-2xl mx-auto mb-12">
            <div className="text-xs font-bold uppercase tracking-[0.25em] text-brand-300 mb-3">Değerlerimiz</div>
            <h2 className="font-display text-4xl md:text-5xl font-bold">Neden Bizimle <span className="gradient-text">Çalışın?</span></h2>
          </div>
          <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-5">
            {[
              [Ruler, "Ölçüye Özel Üretim", "Milimetrik hassasiyetle üretim."],
              [Award, "Kaliteli Malzeme", "Neme dayanıklı, dayanıklı malzemeler."],
              [ShieldCheck, "2 Yıl Garanti", "Tüm ürünlerde kapsamlı garanti."],
              [Truck, "Zamanında Teslimat", "Söz verdiğimiz tarih, eksiksiz."],
              [Sparkles, "Şeffaf Fiyatlandırma", "Detaylı PDF teklif ile net süreç."],
              [Users, "Uzman Ekip", "Deneyimli usta ve teknisyenler."],
            ].map(([Icon, t, d], i) => (
              <div key={`about-value-${t}`} className="rounded-2xl border border-white/10 bg-white/5 p-7">
                <div className="h-12 w-12 rounded-xl gradient-primary grid place-items-center text-white mb-4"><Icon className="h-6 w-6" /></div>
                <h3 className="font-display font-bold text-lg">{t}</h3>
                <p className="mt-1 text-sm text-white/70">{d}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      <section className="mx-auto max-w-4xl px-4 sm:px-6 lg:px-8 py-20">
        <div className="text-center mb-14">
          <div className="text-xs font-bold uppercase tracking-[0.25em] text-brand-600 mb-3">Süreç</div>
          <h2 className="font-display text-4xl md:text-5xl font-bold text-ink-900">Kilometre <span className="gradient-text">Taşlarımız</span></h2>
        </div>
        <ol className="relative border-l-2 border-brand-200 ml-4 space-y-10">
          {[
            ["Kuruluş", "Malatya'nın merkezinde küçük bir atölye ile üretime başladık."],
            ["Genişleme", "Toplu iş projelerini de kapsayacak şekilde atölyemizi büyüttük."],
            ["Dijitalleşme", "Anlık fiyat hesaplama ve online teklif sistemi devreye alındı."],
            ["Bugün", "Yılda yüzlerce proje ve mutlu müşteri ile büyümeye devam ediyoruz."],
          ].map(([t, d], i) => (
            <li key={`milestone-${t}`} className="ml-6">
              <span className="absolute -left-3 h-6 w-6 rounded-full gradient-primary text-white text-xs grid place-items-center font-bold">{i + 1}</span>
              <h3 className="font-display font-bold text-xl text-ink-900">{t}</h3>
              <p className="mt-1 text-ink-500">{d}</p>
            </li>
          ))}
        </ol>
      </section>
    </div>
  );
}
